module.exports = __webpack_public_path__ + "img/band.e1775115.svg";